import { DataGrid, type GridColDef } from '@mui/x-data-grid';
import React from 'react';
import type { DataGridProps, GridValidRowModel } from '@mui/x-data-grid';
import { csCZ } from '@mui/x-data-grid/locales';
import { useIntlTranslations } from '@libs/intl/intl.hooks';

type AppDataGridProps = DataGridProps & {
  rows: GridValidRowModel[];
  columns: GridColDef[];
  sx?: object;
  [key: string]: unknown;
  rowHeight?: number;
  disableColumnMenu?: boolean;
  pageSizeOptions?: number[];
};

const AppDataGrid = (props: AppDataGridProps) => {
  const {
    rows,
    columns,
    columnHeaderHeight,
    hideFooter,
    rowHeight,
    pageSizeOptions = [10],
    disableColumnMenu = false,
  } = props;

  const { t } = useIntlTranslations();

  const gridColumns: readonly GridColDef[] = React.useMemo(
    () =>
      columns.map(col => ({
        ...col,
        headerName: col.headerName ? t(col.headerName) : col.headerName,
      })),
    [columns, t],
  );

  return (
    <div
      id="stock-page-header"
      style={{ display: 'flex', flexDirection: 'column', minHeight: '100px' }}
    >
      <DataGrid
        {...props}
        rows={rows}
        columns={gridColumns}
        autoHeight
        localeText={csCZ.components.MuiDataGrid.defaultProps.localeText}
        disableColumnMenu={disableColumnMenu}
        sx={{
          ...props.sx,
          fontSize: '12px',
          border: 'none',
          '& .MuiDataGrid-columnSeparator': {
            display: 'none',
          },
        }}
        pageSizeOptions={pageSizeOptions}
        disableRowSelectionOnClick
        density="compact"
        rowHeight={rowHeight ?? 60}
        columnHeaderHeight={columnHeaderHeight}
        hideFooter={hideFooter}
      />
    </div>
  );
};

export default AppDataGrid;
